import React from 'react'
import { Card, CardContent, Box } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { useStyles } from './NewsCardSkeleton.styles'

const NewsCardSkeleton = () => {
  const classes = useStyles()

  return (
    <Card className={classes.card}>
      <Skeleton
        variant="rect"
        className={classes.img}
        animation="wave"
        height={250}
      />
      <CardContent className={classes.cardContent}>
        <Box className={classes.titleWrapper}>
          <Skeleton variant="text" width="100%" animation="wave" />
          <Skeleton variant="text" width="80%" animation="wave" />
        </Box>
        <Box className={classes.actions}>
          <Skeleton
            variant="rect"
            className={classes.actionsButton}
            animation="wave"
          />
        </Box>
      </CardContent>
    </Card>
  )
}

export default NewsCardSkeleton
